import { makeStyles } from "@mui/styles";

const useDyanamicGalleryStyle = makeStyles(() => ({
  activeColor: {
    color: "#4B9EF9",
  },
}));

export default useDyanamicGalleryStyle;
